import React from "react";
import styles from './BackgroundScene.module.css';

interface SceneProps {
  modelScale?: number;
}

/**
 * Simple Background Scene component without Three.js
 */
function BackgroundScene({ modelScale = 1.5 }: SceneProps) {
  return (
    <div className={styles.sceneContainer}>
      {/* Simple background without 3D rendering */}
    </div>
  );
}

export default BackgroundScene;